import { render, staticRenderFns } from "./grossing-touch-request-sidepanel.vue?vue&type=template&id=b99edc6a&"
import script from "./grossing-touch-request-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-request-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports